import axios from '../axios';
import API from 'actions/api';

const baseUrl = API + '/payment';

export const stripePaymentService = {
  /**
   * Create a Stripe hosted Checkout Session.
   *
   * The backend creates the session on Stripe and returns the URL of
   * Stripe's hosted payment page.  The frontend then redirects the
   * user directly to that URL — card details are never entered on our site.
   *
   * @param {string} subscriptionType  "month" | "year"
   * @param {number} amount            Per-unit price (e.g. 2.00 for €2/month)
   * @param {number} duration          Number of months or years
   * @returns {Promise<{ checkout_url: string }>}
   */
  createCheckoutSession: async (subscriptionType, amount, duration) => {
    try {
      const { data } = await axios.post(`${baseUrl}/create_checkout_session/`, {
        subscription_type: subscriptionType,
        amount,
        duration,
      });
      return data; // { checkout_url: "https://checkout.stripe.com/..." }
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Verify a completed Checkout Session after Stripe redirects the user back.
   *
   * Called on the /payment-success page with the session_id that Stripe
   * appended to the return URL (?session_id=cs_xxx).
   *
   * @param {string} sessionId  Stripe session ID (cs_xxx)
   * @returns {Promise<{ success: boolean }>}
   */
  verifyCheckoutSession: async (sessionId) => {
    try {
      const { data } = await axios.post(`${baseUrl}/verify_checkout_session/`, {
        session_id: sessionId,
      });
      return data; // { success: true }
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};
